const TONES = {
    // workflow
    draft: "bg-gray-100 text-gray-700",
    open: "bg-gray-100 text-gray-700",
    pending_approval: "bg-amber-100 text-amber-700",
    pending: "bg-amber-100 text-amber-700",
    for_revision: "bg-amber-100 text-amber-700",
    needs_revalidation: "bg-amber-100 text-amber-700",
    validated: "bg-emerald-100 text-emerald-700",
    approved: "bg-emerald-100 text-emerald-700",
    approved_d: "bg-emerald-100 text-emerald-700",
    delivered: "bg-emerald-100 text-emerald-700",
    released: "bg-emerald-100 text-emerald-700",
    converted: "bg-blue-100 text-blue-700",
    rejected: "bg-red-100 text-red-700",
    rejected_d: "bg-red-100 text-red-700",
    cancelled: "bg-gray-200 text-gray-700",
    expired: "bg-gray-200 text-gray-700",
    // SAP
    queued: "bg-blue-100 text-blue-700",
    queued_for_sap: "bg-blue-100 text-blue-700",
    posting_to_sap: "bg-blue-100 text-blue-700",
    posted_to_sap: "bg-emerald-100 text-emerald-700",
    posted: "bg-emerald-100 text-emerald-700",
    sap_posting_failed: "bg-red-100 text-red-700",
    failed: "bg-red-100 text-red-700",
    // inquiry
    available: "bg-emerald-100 text-emerald-700",
    available_in_x_batches: "bg-blue-100 text-blue-700",
    not_enough: "bg-amber-100 text-amber-700",
    without_stock: "bg-red-100 text-red-700",
    // session
    active: "bg-emerald-100 text-emerald-700",
    inactive: "bg-gray-200 text-gray-700",
    scheduled: "bg-blue-100 text-blue-700",
    assigned: "bg-blue-100 text-blue-700",
    not_posted: "bg-gray-100 text-gray-700",
};

export default function StatusBadge({ status, className = "" }) {
    const key = String(status || "").toLowerCase();
    const tone = TONES[key] || "bg-gray-100 text-gray-700";
    return (
        <span className={`sc-pill ${tone} ${className}`} data-testid={`status-${key}`}>
            {key.replaceAll("_", " ")}
        </span>
    );
}
